module.exports = __webpack_public_path__ + "media/images/img_voice_01-8de75081962a273995fbe5600022f04d.png";